<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>To my family – especially my wife, Shirley.</p><br/>
<p style="text-indent: 0em;">To my professional colleagues, in which I include ‘the opposition’ – they know who they are!</p><br/>
<p style="text-indent: 0em;"> To my best friends, Phil and Gayle, for their generous hospitality in New Mexico, when I was first getting to grips with the incipient Wonderbra Manoeuvre.</p><br/>
<p style="text-indent: 0em;">The publication team at AM – again, they know who they are.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?70e81fa5